export default __webpack_public_path__ + "static/media/html.23784160.png";